module.exports = __webpack_public_path__ + "img/Boy_020034.6196704e.png";